<div
  mat-dialog-title
  class="dialog-header">
  <div class="header-icon">
    <mat-icon>{{ data.isNew ? 'add_circle' : 'edit' }}</mat-icon>
  </div>
  <div class="header-content">
    <h2>{{ data.isNew ? 'Neuer Wert' : 'Wert bearbeiten' }}</h2>
    <p>{{ data.isNew ? 'Fügen Sie einen neuen Wert zum Keyword hinzu' : 'Bearbeiten Sie die Wert-Details' }}</p>
  </div>
</div>

@if(kwAddForm){
<mat-dialog-content [formGroup]="kwAddForm">
  <div class="form-container">
    <mat-form-field
      appearance="outline"
      class="form-field"
      hideRequiredMarker="true">
      <mat-label>Wert Name</mat-label>
      <mat-icon matPrefix>label_important</mat-icon>
      <input
        matInput
        formControlName="keywordValueName"
        placeholder="z.B. admin@example.com oder Rollenname"
        autofocus />
      @if(kwAddForm.get('keywordValueName')?.hasError('required')){
      <mat-error>
        <mat-icon>error</mat-icon>
        Wert Name ist erforderlich </mat-error
      >}
      <mat-hint>Der Hauptwert des Eintrags (z.B. E-Mail-Adresse, Name, ID)</mat-hint>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      class="form-field"
      hideRequiredMarker="true">
      <mat-label>Beschreibung (optional)</mat-label>
      <mat-icon matPrefix>description</mat-icon>
      <textarea
        matInput
        formControlName="description"
        placeholder="Zusätzliche Informationen oder Kontext"
        rows="3"></textarea>
      <mat-hint>Optionale Beschreibung oder Zusatzinformationen</mat-hint>
    </mat-form-field>

    <div class="info-box">
      <mat-icon>info</mat-icon>
      <div class="info-content">
        <strong>Hinweis:</strong>
        <span>Die Reihenfolge der Werte kann im Hauptdialog per Drag & Drop angepasst werden.</span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-stroked-button
    (click)="discard()"
    class="action-button">
    <mat-icon>close</mat-icon>
    Abbrechen
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="kwAddForm.invalid"
    class="action-button">
    <mat-icon>{{ data.isNew ? 'add' : 'save' }}</mat-icon>
    {{ data.isNew ? 'Hinzufügen' : 'Speichern' }}
  </button>
</mat-dialog-actions>
}
